export default class Printer {
    
    name = null
    width = null
    selected = false

    constructor(name, width = '57', selected = false) {
        this.name = name
        this.width = width
        this.selected = selected
    }
}